import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';

import store from "./store";

const root = document.getElementById('root');
const localeId = root.getAttribute('data-locale');

ReactDOM.hydrate(
  <Provider store={store}>
    <App localeId={localeId} />
  </Provider>, root);
